import { Link } from 'react-router-dom'
import './Header.css'

const Header = () => {
  return (
    <header>
      <div className='header__content mw-1340'>
        <h1>
          <Link to='/'>Тести МГП</Link>
        </h1>
      </div>
    </header>
  )
}

export default Header
